import { takeLatest, put } from 'redux-saga/effects';
import { createAxios } from '../utils/utils';
import { MALL_ORDERS_82, APP_ORDERS_82, GAME_LIST_84 } from '../config';
import {
  GET_GOOD_ORDER_LIST,
  SET_GOOD_ORDER_LOADING,
  SET_GOOD_ORDER_LIST,
  SET_APPS_ORDER_LOADING,
  SET_APPS_ORDER_LIST,
  GET_APPS_ORDER_LIST,
  GET_GAME_LIST,
  SET_GAME_LIST_LOADING,
  SET_GAME_LIST,
} from '../constants/order';
import { logNative } from '../utils/utils';

function* fetchMallOrders({ params }) {
  if (params.refresh) {
    yield put({ type: SET_GOOD_ORDER_LOADING, loading: true });
  }
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(MALL_ORDERS_82, { params });

    if (res.data.status === 0) {
      yield put({
        type: SET_GOOD_ORDER_LIST,
        payload: {
          list: res.data.data.dataList,
          total: res.data.data.total,
          params,
        },
      });
    } else if (res.data.status === 200500) {
      yield put({
        type: SET_GOOD_ORDER_LIST,
        payload: {
          list: res.data.data.dataList,
          total: res.data.data.total,
          params,
        },
      });
    }
    if (params.refresh) {
      yield put({ type: SET_GOOD_ORDER_LOADING, loading: false });
    }
  } catch (error) {
    logNative(`logging error${error}`, error);
  }
}

export function* watchFetchMallOrders() {
  yield takeLatest(GET_GOOD_ORDER_LIST, fetchMallOrders);
}

function* fetchAppsOrders({ params }) {
  if (params.refresh) {
    yield put({ type: SET_APPS_ORDER_LOADING, loading: true });
  }
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(APP_ORDERS_82, { params });
    if (res.data.status === 0) {
      yield put({
        type: SET_APPS_ORDER_LIST,
        payload: {
          list: res.data.data.dataList,
          total: res.data.data.total,
          params,
        },
      });
    } else if (res.data.status === 200500) {
      yield put({
        type: SET_APPS_ORDER_LIST,
        payload: {
          list: res.data.data.dataList,
          total: res.data.data.total,
          params,
        },
      });
    }
    if (params.refresh) {
      yield put({ type: SET_APPS_ORDER_LOADING, loading: false });
    }
  } catch (error) {
    logNative(`logging error${error}`, error);
  }
}

export function* watchFetchAppsOrders() {
  yield takeLatest(GET_APPS_ORDER_LIST, fetchAppsOrders);
}

function* fetchGameOrders({ params }) {
  if (params.refresh) {
    yield put({ type: SET_GAME_LIST_LOADING, loading: true });
  }
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(GAME_LIST_84, { params });
    if (res.data.status === 0) {
      yield put({
        type: SET_GAME_LIST,
        payload: {
          list: res.data.data.dataList,
          total: res.data.data.total,
          params,
        },
      });
    } else if (res.data.status === 200500) {
      yield put({
        type: SET_GAME_LIST,
        payload: {
          list: res.data.data.dataList,
          total: res.data.data.total,
          params,
        },
      });
    }
    if (params.refresh) {
      yield put({ type: SET_GAME_LIST_LOADING, loading: false });
    }
  } catch (error) {
    logNative(`logging error${error}`, error);
  }
}

export function* watchFetchGameOrders() {
  yield takeLatest(GET_GAME_LIST, fetchGameOrders);
}
